/* Vid Natur — interacciones del tema. Sin dependencias.
   Agencia Distinto · 15 de agosto de 2026 */
(function () {
  'use strict';

  /* Aparición al entrar en pantalla. Si no hay IntersectionObserver, todo
     queda visible: nunca se esconde contenido por una falla de JS. */
  function revelar(raiz) {
    var items = (raiz || document).querySelectorAll('.vn-rev:not(.vn-on)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (n) { n.classList.add('vn-on'); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = +(e.target.dataset.rev || 0);
        setTimeout(function () { e.target.classList.add('vn-on'); }, i * 70);
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    items.forEach(function (n) { obs.observe(n); });
  }

  /* Rota un grupo de elementos marcando .vn-on en el índice activo. */
  function rotador(caja, selector, ms) {
    var grupos = selector.map(function (s) { return caja.querySelectorAll(s); });
    var n = grupos[0].length;
    if (n < 2) { grupos.forEach(function (g) { if (g[0]) g[0].classList.add('vn-on'); }); return; }
    var i = 0, reloj;
    function pintar(x) {
      i = (x + n) % n;
      grupos.forEach(function (g) {
        for (var k = 0; k < g.length; k++) g[k].classList.toggle('vn-on', k === i);
      });
    }
    function arrancar() { reloj = setInterval(function () { pintar(i + 1); }, ms); }
    function parar() { clearInterval(reloj); }
    caja.querySelectorAll('[data-ir]').forEach(function (b) {
      b.addEventListener('click', function () { parar(); pintar(+b.dataset.ir); arrancar(); });
    });
    caja.addEventListener('mouseenter', parar);
    caja.addEventListener('mouseleave', arrancar);
    pintar(0); arrancar();
  }

  function iniciar(raiz) {
    raiz = raiz || document;
    revelar(raiz);

    raiz.querySelectorAll('[data-vn-hero]').forEach(function (c) {
      rotador(c, ['.vn-hero__fondo', '.vn-hero__slide', '.vn-hero__dot'], 6000);
    });
    raiz.querySelectorAll('[data-vn-testi]').forEach(function (c) {
      rotador(c, ['.vn-testi__foto', '.vn-testi__texto', '.vn-puntos button'], 7000);
    });
    raiz.querySelectorAll('[data-vn-anuncios]').forEach(function (c) {
      rotador(c, ['.vn-anun__msg'], 4200);
    });

    /* Acordeón horizontal de colecciones: se abre al pasar el mouse y al enfocar
       con teclado, para que también funcione sin ratón. */
    raiz.querySelectorAll('.vn-acor').forEach(function (a) {
      var hojas = a.querySelectorAll('.vn-acor__hoja');
      hojas.forEach(function (h) {
        function abrir() { hojas.forEach(function (o) { o.classList.toggle('vn-on', o === h); }); }
        h.addEventListener('mouseenter', abrir);
        h.addEventListener('focus', abrir);
      });
      if (hojas[0]) hojas[0].classList.add('vn-on');
    });

    /* Carrusel por scroll nativo: sin librería, y en móvil se arrastra con el dedo. */
    raiz.querySelectorAll('.vn-carr').forEach(function (c) {
      var pista = c.querySelector('.vn-carr__pista');
      c.querySelectorAll('[data-mover]').forEach(function (b) {
        b.addEventListener('click', function () {
          var primero = pista.firstElementChild;
          if (!primero) return;
          var paso = primero.getBoundingClientRect().width + 24;
          pista.scrollBy({ left: paso * +b.dataset.mover, behavior: 'smooth' });
        });
      });
    });

    /* Menú móvil: drawer con overlay. */
    raiz.querySelectorAll('[data-vn-cab]').forEach(function (cab) {
      var drawer = cab.querySelector('[data-vn-drawer]');
      var burger = cab.querySelector('[data-vn-menu]');
      if (!drawer || !burger) return;
      function abierto() { return cab.classList.contains('vn-menu-abierto'); }
      function setOpen(on) {
        cab.classList.toggle('vn-menu-abierto', on);
        document.body.classList.toggle('vn-menu-abierto', on);
        burger.setAttribute('aria-expanded', on ? 'true' : 'false');
        burger.setAttribute('aria-label', on ? 'Cerrar menú' : 'Abrir menú');
        if (on) drawer.removeAttribute('hidden');
        else drawer.setAttribute('hidden', '');
      }
      burger.addEventListener('click', function () { setOpen(!abierto()); });
      drawer.querySelectorAll('[data-vn-menu-close]').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });
      drawer.querySelectorAll('.vn-drawer__sub a, .vn-drawer__link').forEach(function (a) {
        a.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && abierto()) setOpen(false);
      });
    });

    /* Cuenta regresiva. La fecha de fin la fija la sección en data-fin. */
    raiz.querySelectorAll('[data-vn-reloj]').forEach(function (r) {
      var fin = +r.dataset.fin * 1000;
      function pintar() {
        var falta = Math.max(0, fin - Date.now()) / 1000;
        var v = [Math.floor(falta / 86400), Math.floor(falta / 3600) % 24,
                 Math.floor(falta / 60) % 60, Math.floor(falta) % 60];
        r.querySelectorAll('b').forEach(function (b, i) {
          b.textContent = String(v[i]).padStart(2, '0');
        });
      }
      pintar(); setInterval(pintar, 1000);
    });

    /* Pestañas de la ficha de producto. */
    raiz.querySelectorAll('.vn-pestanas').forEach(function (caja) {
      caja.querySelectorAll('button').forEach(function (bt) {
        bt.addEventListener('click', function () {
          caja.querySelectorAll('button').forEach(function (o) { o.classList.toggle('vn-on', o === bt); });
          var zona = caja.parentElement;
          zona.querySelectorAll('.vn-panel').forEach(function (pa) {
            pa.classList.toggle('vn-on', pa.dataset.panel === bt.dataset.tab);
          });
        });
      });
    });

    /* Cambio de variante: precio y tachado pertenecen a la misma presentación. */
    raiz.querySelectorAll('.vn-prod__variantes input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var ficha = radio.closest('.vn-prod');
        if (!ficha || !radio.checked) return;
        var destino = ficha.querySelector('[data-precio-destino]');
        if (destino && radio.dataset.precio) destino.textContent = radio.dataset.precio;
        var anterior = ficha.querySelector('[data-precio-anterior]');
        if (anterior) {
          anterior.textContent = radio.dataset.precioAnterior || '';
          anterior.hidden = !radio.dataset.precioAnterior;
        }
      });
    });

    /* Galería: la miniatura cambia la imagen principal. */
    raiz.querySelectorAll('.vn-prod__mini[data-src]').forEach(function (mini) {
      mini.addEventListener('click', function () {
        var grande = document.querySelector('.vn-prod__principal img');
        if (grande) grande.src = mini.dataset.src;
        document.querySelectorAll('.vn-prod__mini').forEach(function (o) { o.classList.toggle('vn-on', o === mini); });
      });
    });

    /* Los selects con data-auto mandan su formulario al cambiar. */
    raiz.querySelectorAll('select[data-auto]').forEach(function (s) {
      s.addEventListener('change', function () { s.form && s.form.submit(); });
    });

    /* Corazón de favoritos: guarda en el navegador y sobrevive la recarga. */
    var FAVS = 'vn_favoritos';
    function leerFavs () { try { return JSON.parse(localStorage.getItem(FAVS)) || []; } catch (e) { return []; } }
    raiz.querySelectorAll('[data-fav]').forEach(function (b) {
      if (leerFavs().indexOf(b.dataset.fav) > -1) b.classList.add('vn-fav-on');
      b.addEventListener('click', function () {
        var lista = leerFavs(), i = lista.indexOf(b.dataset.fav);
        if (i > -1) lista.splice(i, 1); else lista.push(b.dataset.fav);
        try { localStorage.setItem(FAVS, JSON.stringify(lista)); } catch (e) {}
        b.classList.toggle('vn-fav-on', i === -1);
      });
    });

    /* Contador de cantidad. En el carrito, cambiar la cantidad re-envía el
       formulario para que Shopify recalcule los totales en el servidor. */
    raiz.querySelectorAll('[data-paso]').forEach(function (b) {
      b.addEventListener('click', function () {
        var caja = b.closest('.vn-cant'), inp = caja && caja.querySelector('input');
        if (!inp) return;
        var minimo = +inp.min || 1;
        inp.value = Math.max(minimo, (+inp.value || minimo) + (+b.dataset.paso));
        var formCarrito = b.closest('form[data-vn-carrito]');
        if (formCarrito) formCarrito.submit();
      });
    });

    /* Código de descuento: Shopify lo aplica por URL y lo recuerda en el checkout. */
    raiz.querySelectorAll('[data-vn-descuento]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wrap = b.closest('.vn-resumen') || b.parentElement;
        var inp = wrap.querySelector('[data-vn-descuento-input]') || b.parentElement.querySelector('input');
        var msg = wrap.querySelector('[data-vn-descuento-msg]');
        var code = inp && inp.value.trim();
        if (!code) {
          if (msg) { msg.hidden = false; msg.style.color = '#B42318'; msg.textContent = 'Escribe un código de descuento.'; }
          return;
        }
        if (msg) { msg.hidden = false; msg.style.color = 'var(--texto-suave)'; msg.textContent = 'Aplicando código…'; }
        location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
    });
    /* Feedback si volvemos del discount URL sin cambio de precio (código inválido/ausente). */
    (function () {
      var params = new URLSearchParams(location.search);
      var msg = document.querySelector('[data-vn-descuento-msg]');
      if (!msg) return;
      if (params.get('discount') === 'invalid' || params.get('vn_descuento') === 'fail') {
        msg.hidden = false; msg.style.color = '#B42318';
        msg.textContent = 'Ese código no aplica. Revisa el cupón o continúa sin descuento.';
      }
    })();

    /* Copiar el código de cupón al portapapeles. */
    raiz.querySelectorAll('[data-copiar]').forEach(function (b) {
      b.addEventListener('click', function () {
        var texto = b.dataset.copiar, previo = b.textContent;
        var listo = function () { b.textContent = 'Copiado'; setTimeout(function () { b.textContent = previo; }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(texto).then(listo, function(){});
        else listo();
      });
    });
  }

  /* Horizon scrollea dentro de .page-wrapper con html/body en overflow:hidden.
     'scroll' no burbujea, pero con capture:true lo vemos venga del contenedor
     que venga — window.onscroll aca no dispara nunca. */
  document.addEventListener('scroll', function (e) {
    var y = (e.target === document)
      ? (document.scrollingElement || document.documentElement).scrollTop
      : (e.target.scrollTop || 0);
    document.querySelectorAll('.vn-cab').forEach(function (c) {
      c.classList.toggle('vn-pegada', y > 60);
    });
  }, { capture: true, passive: true });

  document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  /* El editor de temas recarga secciones sueltas: hay que re-inicializarlas. */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
